import { eachOfLimit, retry } from 'async';

function asyncParallelForEach(coll, parallelLimit = 1, iteratee, eachMaxTry = { times: 1, interval: 0 }) {
    return new Promise((resolve) => {
        const collLength = Array.isArray(coll) ? coll.length : Object.keys(coll).length;
        if (parallelLimit === -1) {
            parallelLimit = collLength;
        }
        const results = Array.isArray(coll) ? [] : {};
        let doneCnt = 0;
        eachOfLimit(coll, parallelLimit, (item, index, callback) => {
            retry(eachMaxTry, (callback) => {
                Promise.resolve(iteratee(item, index))
                    .then((...args) => callback(null, ...args))
                    .catch(callback);
            }, (err, result) => {
                if (err) {
                    results[index] = { error: err };
                }
                else {
                    results[index] = { value: result };
                }
                doneCnt++;
                if (doneCnt === collLength) { // end
                    resolve(results);
                }
                callback();
            });
        });
    });
}
var BACK_OFF_RETRY;
(function (BACK_OFF_RETRY) {
    function randomBetween(minMs, maxMs) {
        return function randomBackoff() {
            return Math.floor(Math.random() * (maxMs - minMs + 1) + minMs);
        };
    }
    BACK_OFF_RETRY.randomBetween = randomBetween;
    function exponential() {
        return function exponentialBackoff(retryCount) {
            // start from 100, then 200, 400, 800, 1600, ....
            return 50 * Math.pow(2, retryCount - 1);
        };
    }
    BACK_OFF_RETRY.exponential = exponential;
})(BACK_OFF_RETRY || (BACK_OFF_RETRY = {}));

export { asyncParallelForEach, BACK_OFF_RETRY };
//# sourceMappingURL=index.es.js.map
